import { render, staticRenderFns } from "./JudgeUser.vue?vue&type=template&id=6ceb1764&scoped=true&"
import script from "./JudgeUser.vue?vue&type=script&lang=js&"
export * from "./JudgeUser.vue?vue&type=script&lang=js&"
import style0 from "./JudgeUser.vue?vue&type=style&index=0&id=6ceb1764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb1764",
  null
  
)

export default component.exports